export default "__VITE_ASSET__DGxW0Rgm__"